import { gql } from '@apollo/client'

const SCREENSHOT_FEEDBACK_FIELDS = gql`
  fragment ScreenshotFeedbackFields on ScreenshotFeedbackByPageType {
    id
    title
    description
    page
    platform {
      id
    }
    images {
      url
      width
      height
    }
  }
`

export const CREATE_SCREENSHOT_FEEDBACK = gql`
  mutation createScreenshotFeedback($createScreenshotFeedbackInput: CreateScreenshotFeedbackInput!) {
    createScreenshotFeedback(createScreenshotFeedbackInput: $createScreenshotFeedbackInput) {
      id
    }
  }
`

export const FIND_ONE_SCREENSHOT_FEEDBACK_BY_PAGE = gql`
  ${SCREENSHOT_FEEDBACK_FIELDS}
  query findOneScreenshotFeedbackByPage($page: CMSScreenshotPages!, $platformSlug: String!) {
    findOneScreenshotFeedbackByPage(page: $page, platformSlug: $platformSlug) {
      ...ScreenshotFeedbackFields
    }
  }
`

export const UPDATE_SCREENSHOT_FEEDBACK = gql`
  mutation updateScreenshotFeedback($updateScreenshotFeedbackInputFieldName: UpdateScreenshotFeedbackInput!) {
    updateScreenshotFeedback(updateScreenshotFeedbackInputFieldName: $updateScreenshotFeedbackInputFieldName) {
      id
    }
  }
`
